<template>
  <b-container>
    <div>
      <div class="row no-gutters">
        <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 ">
          <div class="w-100">

            <div class="text-center mt-3 mb-1">
              <img :src="brandLogo" alt="Logo Login" class="logo-img">
            </div>

            <login-component
              v-if="showLoginComponent"
              :can-sign-up="canSignUp"
              :error="error"
              @inputMail="inputMail"
              @showForgotPasswordView="showForgotPasswordView"
              @showRegister="showRegister"
              @showSmsCodeView="showSmsCodeView"
            />

            <Register
              v-if="showRegisterComponent && canSignUp"
              @showLoginView="showLoginView"
              @showUserCreateSuccessful="showUserCreateSuccessful"
            />

            <sms-code-component
              v-if="showSmsCodeComponent"
              ref="smsCodeComponent"
              @showLoginView="showLoginView"
            />

            <validate-account-component
              v-if="showValidateAccountComponent"
              @alreadyValidate="alreadyValidate"
              @showLoginView="showLoginView"
              @showLoginViewError="showLoginViewError"
            />

            <forgot-password-component
              v-if="showForgotPasswordComponent"
              :email="email"
              :token-is-expired="tokenIsExpired"
              @showLoginView="showLoginView"
            />

            <reset-password-component
              v-if="showResetPasswordComponent"
              @showLoginView="showLoginView"
              @tokenExpired="tokenExpired"
            />

            <user-create-successful
              v-if="showUserCreateSuccessfulComponent"
              :email="email"
              @showLoginView="showLoginView"
            />

          </div>
        </div>

        <div id="col-right-with-image"
             :style="{ 'background-image': 'url(' + brandBackground + ')' }"
             class="col-sm-12 col-md-12 col-lg-8 d-flex flex-row">
          <div id="left-banner"></div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import i18n from '../../i18n'
import LoginComponent from './components/LoginComponent'
import Register from '../auth/Register'
import ForgotPasswordComponent from './components/ForgotPasswordComponent'
import ValidateAccountComponent from './components/ValidateAccountComponent'
import SmsCodeComponent from './components/SmsCodeComponent'
import ResetPasswordComponent from './components/ResetPasswordComponent'
import UserCreateSuccessful from '../auth/UserCreateSuccessful'

export default {
  name: 'Login',

  components: {
    ResetPasswordComponent,
    SmsCodeComponent,
    ValidateAccountComponent,
    ForgotPasswordComponent,
    LoginComponent,
    i18n,
    Register,
    UserCreateSuccessful
  },

  data() {
    return {
      currentComponent: this.$route.params.component,
      email: null,
      error: null,
      tokenIsExpired: false,
    }
  },

  computed: {
    ...mapGetters('brand', ['brand']),

    brandLogo() {
      return require(`@/assets/images/${this.brand.key}/logo.png`)
    },
    brandBackground() {
      console.log("brandLogo", this.brand.key)
      return require(`@/assets/images/${this.brand.key}/login-background.png`)
    },

    canSignUp() {
      console.log("canSignUp", this.brand.features.signup)
      return this.brand.features.signup
    },

    showLoginComponent() {
      return this.currentComponent ? this.currentComponent === 'login' : true
    },
    showSmsCodeComponent() {
      return this.currentComponent === 'smsCode'
    },
    showValidateAccountComponent() {
      return this.currentComponent === 'validateAccount'
    },
    showForgotPasswordComponent() {
      return this.currentComponent === 'forgotPassword'
    },
    showResetPasswordComponent() {
      return this.currentComponent === 'resetPassword'
    },
    showRegisterComponent() {
      return this.currentComponent === 'register'
    },
    showUserCreateSuccessfulComponent() {
      return this.currentComponent === 'createSuccessful'
    }
  },

  mounted() {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
  },

  methods: {
    alreadyValidate(error) {
      this.error = error
      this.currentComponent = 'login'
    },
    tokenExpired() {
      this.currentComponent = 'forgotPassword'
      this.tokenIsExpired = true
    },
    showLoginView() {
      this.currentComponent = 'login'
    },
    showLoginViewError(error) {
      this.error = error
      this.currentComponent = 'login'
    },
    showSmsCodeView(username, password, phoneNumber) {
      this.currentComponent = 'smsCode'
      this.$refs.smsCodeComponent.username = username
      this.$refs.smsCodeComponent.password = password
      this.$refs.smsCodeComponent.phoneNumber = phoneNumber
    },
    showValidateAccountView() {
      this.currentComponent = 'validateAccount'
    },
    showForgotPasswordView() {
      this.currentComponent = 'forgotPassword'
    },
    showResetPasswordView() {
      this.currentComponent = 'resetPassword'
    },
    showRegister() {
      this.currentComponent = 'register'
    },
    showUserCreateSuccessful(currentMail) {
      this.email = currentMail
      this.currentComponent = 'createSuccessful'
    },
    inputMail(currentMail) {
      this.email = currentMail
    }
  }
}
</script>

<style scoped>

b-container {
  padding: 0;
}

.container {
  padding: 0;
}

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
  padding-left: 50px;
  height: 100vh;
  background-color: white;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none !important;
  }
}

@media (max-width: 500px) {
  #col-left-with-text {
    padding-right: 40px;
    padding-left: 40px;
  }
}

@media (max-height: 700px) {
  #col-left-with-text {
    height: auto;
  }
}

.logo-img {
  max-height: 140px;
}

h1 {
  font-size: var(--title-level-one-font-size);
}

h2 {
  font-size: var(--title-level-two-font-size);
}

.forgot-password-link {
  color: var(--main-text-color);
}

#left-banner {
  height: 100%;
  width: 50px;
  background-color: white;
  border-radius: 0 25px 25px 0;
  box-shadow: 8px 0 10px #0000001A;
}

a {
  color: var(--main-color);
}

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue